<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <transition name="fade">
          <div class="wrapper" v-if="textPageTitle">
            <div class="title title-main text-page-title">
              <img src="../img/Polygon2.svg" class="text-page-arrow-left" />
              <img src="../img/Polygonhead.svg" class="text-page-arrow-left" />
              {{ textPageTitle.toUpperCase() }}
              <img src="../img/Polygonhead.svg" class="text-page-arrow-right" />
              <img src="../img/Polygon2.svg" class="text-page-arrow-right" />
            </div>
            <div class="desc" v-html="textPageHeader"></div>
            <div class="desc" v-html="textPageContent"></div>
          </div>
        </transition>
      </div>
    </div>
    <footer class="new-footer">
      <div class="footer-top">
        <div class="wrapper">
          <div class="footer-links">
            <a 
              v-for="page in footerPages" 
              :key="page.id"
              @click="$parent.goToPage(page)" 
              class="footer-link"
            >
              {{ page.title.toUpperCase() }}
            </a>
          </div>
        </div>
      </div>
      <div class="footer-middle">
        <div class="wrapper">
          <div class="footer-column footer-column-left">
            <div class="footer-info" v-if="$parent.settings">
              <div class="footer-info-item" v-if="$parent.settings.company_name"><span class="footer-info-label">COMPANY NAME:</span> {{ $parent.settings.company_name }}</div>
              <div class="footer-info-item" v-if="$parent.settings.company_reg_number"><span class="footer-info-label">REGISTRATION NUMBER:</span> {{ $parent.settings.company_reg_number }}</div>
              <div class="footer-info-item" v-if="$parent.settings.company_address"><span class="footer-info-label">ADDRESS:</span> {{ $parent.settings.company_address }}</div>
            </div>
          </div>
          <div class="footer-column footer-column-center">
            <router-link to="/" class="footer-logo">
              <img src="../img/footer logo.svg" class="footer-logo-img" />
            </router-link>
          </div>
          <div class="footer-column footer-column-right">
            <div class="footer-support">
              <div class="footer-support-email" v-if="$parent.settings && $parent.settings.support_email">SUPPORT: {{ $parent.settings.support_email }}</div>
              <div class="footer-social-icons">
                <a
                  v-for="link in $parent.socials"
                  :key="link.image"
                  :href="link.link"
                  target="_blank"
                  class="footer-social-icon"
                >
                  <img 
                    :src="getSocialIcon(link.link)" 
                    :alt="link.link" 
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="wrapper">
          <div class="footer-copyright" v-if="$parent.settings && $parent.settings.copyright">
            {{ $parent.settings.copyright }}
          </div>
          <div class="footer-payment-methods">
            <img src="../img/Mastercard.svg" class="payment-icon" alt="Mastercard" />
            <img src="../img/visa-pay.svg" class="payment-icon" alt="Visa" />
            <img src="../img/apple-pay.svg" class="payment-icon" alt="Apple Pay" />
            <img src="../img/google-pay.svg" class="payment-icon" alt="Google Pay" />
          </div>
        </div>
      </div>
    </footer>
  </main>
</template>
<script>
import axios from '@/axios';
import acebookIcon from '../img/acebook.svg';
import instagramIcon from '../img/instagram.svg';
import steamIcon from '../img/steam.svg';

export default {
  name: "TextPage",
  props: [],
  components: {},
  data: function () {
    return {
      acebookIcon: acebookIcon,
      instagramIcon: instagramIcon,
      steamIcon: steamIcon,
      textPageTitle: "",
      textPageHeader: "",
      textPageContent: "",
    };
  },
  computed: {
    footerPages() {
      if (!this.$parent.textPageList || !Array.isArray(this.$parent.textPageList)) {
        return [];
      }
      const keywords = ['terms', 'privacy', 'cookie'];
      return keywords
        .map(keyword => {
          return this.$parent.textPageList.find(page => 
            page.slug && page.slug.toLowerCase().includes(keyword) ||
            page.title && page.title.toLowerCase().includes(keyword)
          );
        })
        .filter(page => page !== undefined);
    }
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.getTextPageContent(this.$route.params.id);
      } else {
        axios.get("static-pages").then((res) => {
          let newList = res.data.payload;
          let newItem = newList.filter(
            (item) =>
              item.title.replace(/ /g, "_").toLowerCase() ==
              this.$route.params.title
          );
          this.getTextPageContent(newItem[0].id);
        });
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getTextPageContent(this.$route.params.id);
    } else {
      axios.get("static-pages").then((res) => {
        let newList = res.data.payload;
        let newItem = newList.filter(
          (item) =>
            item.title.replace(/ /g, "_").toLowerCase() ==
            this.$route.params.title
        );
        this.getTextPageContent(newItem[0].id);
      });
    }
  },
  methods: {
    getSocialIcon(link) {
      if (!link) return '';
      const linkLower = link.toLowerCase();
      
      if (linkLower.includes('facebook') || linkLower.includes('fb')) {
        return this.acebookIcon;
      }
      if (linkLower.includes('instagram')) {
        return this.instagramIcon;
      }
      if (linkLower.includes('steam')) {
        return this.steamIcon;
      }
      return this.acebookIcon;
    },
    isFacebookLink(link) {
      return link && (link.toLowerCase().includes('facebook') || link.toLowerCase().includes('fb'));
    },
    getTextPageContent(id) {
      this.textPageTitle = "";
      this.textPageHeader = "";
      this.textPageContent = "";
      axios
        .get("static-pages/" + id)
        .then((res) => {
          this.textPageTitle = res.data.payload.title;
          this.textPageContent = res.data.payload.content;
          this.textPageHeader = res.data.payload.header;
        });
    },
  },
};
</script>
